import { IconButton } from '@atlaskit/button/new';
import AkHeading from '@atlaskit/heading';
import ArrowRightIcon from '@atlaskit/icon/core/arrow-right';
import { Inline, Text } from '@atlaskit/primitives/compiled';
import React, { ReactNode } from 'react';

import { useAnalytics } from '@townsquare/analytics';
import { Link, type LinkProps } from '@townsquare/router/primitives/link';
import { useMetaClickHandler } from '@townsquare/ui-interactions';

type BrowseMoreLinkProps = Pick<LinkProps, 'to' | 'params' | 'query'> & { onClick?: () => void };

interface HeadingProps {
	children: ReactNode;
	screenType: string;
	onClick?: () => void;
	browseMore?: {
		text: string;
		linkProps: BrowseMoreLinkProps;
	};
}

export const Heading = ({ children, browseMore, screenType }: HeadingProps) => {
	return (
		<Inline alignBlock="center" space="space.100" spread="space-between" shouldWrap>
			<AkHeading size="small" as="h2">
				{children}
			</AkHeading>
			{browseMore && (
				<AsLink screenType={screenType} browseMoreText={browseMore.text} linkProps={browseMore.linkProps} />
			)}
		</Inline>
	);
};

const AsLink = ({
	screenType,
	browseMoreText,
	linkProps,
}: {
	screenType: string;
	browseMoreText: string;
	linkProps: BrowseMoreLinkProps;
}) => {
	const analytics = useAnalytics();

	const { handler } = useMetaClickHandler(
		linkProps.to,
		{
			params: linkProps.params,
			query: linkProps.query,
		},
		() => {
			analytics.ui('staffDirectoryBrowseAllScreenHeading', 'clicked', { screenType });
			linkProps.onClick?.();
		},
	);

	return (
		// eslint-disable-next-line @atlassian/a11y/click-events-have-key-events, @atlassian/a11y/no-static-element-interactions
		<Link {...linkProps} onClick={handler}>
			<Inline alignBlock="center" space="space.100">
				<Text color="color.text.subtlest">{browseMoreText}</Text>
				<IconButton icon={ArrowRightIcon} label="" spacing="compact" />
			</Inline>
		</Link>
	);
};
